// extracted by mini-css-extract-plugin
export default {"sidebarStyleMin":"Sidebar_sidebarStyleMin__gXvXF","listItemMin":"Sidebar_listItemMin__GEv-t","activeMin":"Sidebar_activeMin__ZTMxA"};